import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { useSetState } from 'react-use';

import { SimpleImg } from 'react-simple-img';

import './Image.scss';

/**
 * Image.
 *
 * @see https://github.com/bluebill1049/react-simple-img#-simpleimg
 */
const propTypes = {
  src: PropTypes.string,
  data: PropTypes.object,
  // See additional simpleimg props.
}
const Image = ( { className: customClassName, caption, src, ...p } ) => {

  let imageSrc = !! p.data && p.data.url ? p.data.url : src;
  let placeholder = !! p.data ? p.data.lqip : null;
  if( !! imageSrc ) {
    imageSrc = imageSrc.replace( 'cdn.sanity.io', 'assets.dartdrones.com' );
  }
  if( !! placeholder ) {
    placeholder = placeholder.replace( 'cdn.sanity.io', 'assets.dartdrones.com' );
  }


  const [ isLoaded, setIsLoaded ] = React.useState( false );
  // React.useEffect( () => {
  //   setIsLoaded( true )
  // }, [] );

  /* ------ = Output = --------------------------------------------------------------------- */

  const className = classnames( 'Img', customClassName );

  if( !! caption ) {

    return(

      <figure>
        <SimpleImg
        className={ className }
        src={ imageSrc }
        placeholder={ isLoaded ? imageSrc : placeholder }
        { ...p }
        />
        <figcaption>{ caption }</figcaption>
      </figure>

    )
  }

  return(

    <SimpleImg
    className={ className }
    src={ imageSrc }
    placeholder={ isLoaded ? imageSrc : placeholder }
    { ...p }
    />

  );

};

export default Image;
